import React from "react";

import BulbIcon from "../../icons/bulbIcon.component";
import WalletMoveIcon from "../../icons/walletMoveIcon.component";
import WrenchIcon from "../../icons/wrenchIcon.component";

import { StyledWrapper } from "./calloutPanel.style";
import { calloutSettings } from "./constants";

const CalloutPanel = ({ data }) => {
  const settings = calloutSettings[data.name];

  return (
    <StyledWrapper style={{ backgroundColor: settings.color }}>
      <div className="callout-icon">
        {settings.icon == "bulb" && <BulbIcon opacity="0.6" />}
        {settings.icon == "wallet-move" && <WalletMoveIcon opacity="0.6" />}
        {settings.icon == "wrench" && <WrenchIcon opacity="0.6" />}
      </div>
      <div className="callout-label">{settings.label}</div>
      <div className="callout-value">{data.value}</div>
    </StyledWrapper>
  );
};

export default CalloutPanel;
